import { ApiClient, ServiceResponse, ServiceResponseFactory } from "../../../common";
import { PlatformSettings } from "../../../settings/platformSettings";
import { AppDto } from "../../dtos/out/appDto";
import { UserDto } from "../../dtos/out/userDto";
import { IScopes } from "../interfaces/scopes";

export default class Scopes extends ApiClient implements IScopes {

    private _baseUrl: string;
    constructor(private platformSettings: PlatformSettings) {
        super();
        this._baseUrl = platformSettings.apiUrl + "/auth";
    }

    get baseUrl(): string {
        return this._baseUrl;
    }

    public async getAuthScopes(accessToken: string): Promise<ServiceResponse<Array<string>>> {
        return await super.Get<Array<string>>(this.baseUrl, `auth-scopes`, accessToken);
    }

    public hasScopeAccess(target: UserDto | AppDto, authScope: string): ServiceResponse<boolean> {

        // get a combined list of scopes assigned either directly or via roles
        const roleScopes = target.roles.reduce((scopes, role) => [...scopes, role.authScopes], []).flat();
        let authScopes = target.authScopes.concat(roleScopes).map(scope => scope.toLowerCase());

        // scopes are simply strings that map to a project, class or method within our code,
        // using the convention {AppScope}-{ServiceScope}-{ActionScope}
        let scopeParts = authScope.toLowerCase().split('-');

        let allowedScopes: string[] = [];

        if (scopeParts.length >= 1) {
            allowedScopes.push(scopeParts[0]);
        }

        if (scopeParts.length >= 2) {
            allowedScopes.push(`${scopeParts[0]}-${scopeParts[1]}`);
        }

        if (scopeParts.length >= 3) {
            allowedScopes.push(`${scopeParts[0]}-${scopeParts[1]}-${scopeParts[2]}`);
        }

        var hasAccess = authScopes.some(scope => allowedScopes.includes(scope));
        return ServiceResponseFactory.SuccessfulResponse(hasAccess);
    }

}

export { Scopes } 